import { render, staticRenderFns } from "./VOptions.vue?vue&type=template&id=03f88c71&"
import script from "./VOptions.vue?vue&type=script&lang=js&"
export * from "./VOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports